var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.0528 48.0141H23.9472C10.7429 48.0141 0 37.2681 0 24.0599V23.9542C0 10.746 10.7429 0 23.9472 0H24.0528C37.2571 0 48 10.746 48 23.9542V24.0599C48 37.2681 37.2571 48.0141 24.0528 48.0141ZM23.9472 1.62523C11.6381 1.62523 1.62475 11.6415 1.62475 23.9542V24.0599C1.62475 36.3726 11.6381 46.3889 23.9472 46.3889H24.0528C36.3619 46.3889 46.3752 36.3726 46.3752 24.0599V23.9542C46.3752 11.6415 36.3619 1.62523 24.0528 1.62523H23.9472Z",
    fill: "#344054"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.21 17.5947V21.9747C34.4447 21.8999 33.4503 21.726 32.3504 21.323C30.9141 20.7964 29.845 20.0765 29.1448 19.519V28.3716L29.1269 28.344C29.1383 28.5195 29.1448 28.6983 29.1448 28.8787C29.1448 33.2749 25.5687 36.8537 21.1721 36.8537C16.7755 36.8537 13.1995 33.2749 13.1995 28.8787C13.1995 24.4824 16.7755 20.9021 21.1721 20.9021C21.6027 20.9021 22.0251 20.9362 22.4378 21.0028V25.3194C22.0414 25.178 21.6157 25.1016 21.1721 25.1016C19.0908 25.1016 17.3962 26.7951 17.3962 28.8787C17.3962 30.9622 19.0908 32.6557 21.1721 32.6557C23.2534 32.6557 24.948 30.9606 24.948 28.8787C24.948 28.8007 24.9464 28.7227 24.9415 28.6446V11.4416H29.317C29.3332 11.8121 29.3479 12.186 29.3641 12.5565C29.3934 13.2862 29.6533 13.9867 30.1066 14.5604C30.6379 15.2349 31.4227 16.0182 32.5242 16.6439C33.556 17.2274 34.5243 17.4793 35.21 17.598V17.5947Z",
    fill: "#344054"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTt);
export default __webpack_public_path__ + "static/media/tt.8ef46c8036115a0e41406accd8f1a2dd.svg";
export { ForwardRef as ReactComponent };